export default __webpack_public_path__ + "fonts/[1]icons.svg";